import {Box, Grid, HStack, Show, VStack} from 'platform/foundation';

import {range} from 'ramda';

import i18n from '@dms/i18n';
import {SkeletonLoadingBox} from '@dms/shared';

import {useSkeletonRowCount} from '../../hooks/useSkeletonRowCount';

// Lower bound in pixels; excess placeholders are clipped to the available content area.
const MIN_CARD_HEIGHT_PX = 128;

interface SourcingListSkeletonProps {
  rowCount?: number;
}

export function SourcingListSkeleton(props: SourcingListSkeletonProps) {
  const viewportRowCount = useSkeletonRowCount(MIN_CARD_HEIGHT_PX);
  const rowCount = props.rowCount ?? viewportRowCount;
  return (
    <Box padding={1} paddingTop={3} height="100%" overflow="hidden">
      <div role="status" aria-label={i18n.t('general.labels.loading')}>
        <VStack spacing={3}>
          {range(0, rowCount).map((row) => (
            <Box
              key={row}
              padding={3}
              backgroundColor="general.white"
              borderRadius="small"
              boxShadow="elevation_1"
            >
              <HStack spacing={4}>
                <Show onNotebook onDesktop>
                  <Box width="23%" flexShrink={0}>
                    <SkeletonLoadingBox isLoading height={44} />
                  </Box>
                </Show>
                <VStack grow={1} spacing={4}>
                  <Box width="70%">
                    <SkeletonLoadingBox isLoading height={5} />
                  </Box>
                  <Box width="55%">
                    <SkeletonLoadingBox isLoading height={4} />
                  </Box>
                  <Grid columns={3} spacing={2}>
                    {['comfort', 'safety', 'equipment'].map((slot) => (
                      <SkeletonLoadingBox key={slot} isLoading height={6} />
                    ))}
                  </Grid>
                  <Grid columns={4} spacing={4}>
                    {['position', 'price', 'margin', 'recommendation'].map((slot) => (
                      <SkeletonLoadingBox key={slot} isLoading height={4} />
                    ))}
                  </Grid>
                </VStack>
              </HStack>
            </Box>
          ))}
        </VStack>
      </div>
    </Box>
  );
}
